import { render } from "./ToggleDisplaySettings.vue?vue&type=template&id=5872d552&scoped=true"
import script from "./ToggleDisplaySettings.vue?vue&type=script&lang=ts"
export * from "./ToggleDisplaySettings.vue?vue&type=script&lang=ts"

import "./ToggleDisplaySettings.vue?vue&type=style&index=0&id=5872d552&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5872d552"

export default script